import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import FormGroup from '@mui/material/FormGroup';
import Button from "@mui/material/Button";

import LookUserInput from "../../../user/lookUserInput";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";


const GroheCartLoginHeader = (props) => {

  const {isMobile, inputsValidated, loginButtonClick} = props;

  return (
    <Fragment>
      <GroheCartHeaderCommon title={isMobile ? "grohe.cart.login.mobile.title" : "grohe.cart.login.title"}
                             subTitle={isMobile ? "grohe.cart.login.mobile.subTitle" : "grohe.cart.login.subTitle"}/>
      <FormGroup className="gc-form">
        <div className="gc-form__inputs">
          <div className="gc-form__inputs-block">
            <LookUserInput property="email" inputsValidated={inputsValidated} />
          </div>
          <div className="gc-form__inputs-block">
            <LookUserInput property="password" inputsValidated={inputsValidated} />
          </div>
        </div>
        {isMobile ? null : ( // on mobile we have next and back buttons
          <div className="gc-form__submit">
            <div className="gc-form__submit-left"/>
            <div className="gc-form__submit-right">
              <Button className="look-button look-button--blue look-button--big look-button--large nowrap"
                // disabled={loaderOpened}
                      onClick={loginButtonClick}>
                <FormattedMessage id="grohe.cart.login.loginButton"/>
              </Button>
            </div>
          </div>
        )}
      </FormGroup>
    </Fragment>
  )
};

GroheCartLoginHeader.propTypes = {
  inputsValidated: PropTypes.bool.isRequired,
  loginButtonClick: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  return {
    isMobile,
  };
};

export default connect(mapStateToProps)(GroheCartLoginHeader)
